import React from 'react'
import TwoFactorContainer from '../../../../Components/Forms/FormLayout/TwoFactor'

export default function TwoFactor() {
  return (
    <div className='page-body'>
        <TwoFactorContainer/>
    </div>
  )
}
